import { render, staticRenderFns } from "./ExpertsPage.vue?vue&type=template&id=4eb4b2ca&"
import script from "./ExpertsPage.vue?vue&type=script&lang=js&"
export * from "./ExpertsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports